import { ActionContext, ActionTree } from "vuex";
import { IContentState } from "@/store/modules/content/types";
import { RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type ContentActionContext = ActionContext<IContentState, RootState>;
type ContentActionTree = ActionTree<IContentState, RootState>;

export const actions: ContentActionTree = {
  async fetchContentQuestions(
    context: ContentActionContext,
    sectionId: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      "/content/question/" + sectionId
    );
    context.commit("setContentQuestions", content.data);
  },

  async fetchContentPassages(
    context: ContentActionContext,
    sectionId: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      "/content/passages/" + sectionId
    );
    context.commit("setContentPassages", content.data);
  },
};
